export default "__VITE_ASSET__fOO2gAx9__"